import { Suspense, lazy } from 'react';

import { Loader } from 'shared/ui/Loader';

const BrandManagement = lazy(() => import('./BrandManagement'));

export default () => (
  <Suspense fallback={<Loader />}>
    <BrandManagement />
  </Suspense>
);
